import { defineFieldFormInterface } from "~/entities/field";
import InputInterface from "./InputInterface.vue";

export default defineFieldFormInterface({
  interface: "input",
  component: InputInterface,
});
